import React, { useEffect, useState } from "react";
import { TabContent } from "reactstrap";
import styled from "styled-components";

//components
import {
  TabList,
  History,
  VitalSignTable,
  Measurements,
  IOBalance,
  PriorDocumentsComponent,
  OrderList, // Copy Component moi - can xoa
} from "../TabGreen";

//lodash
import _ from "lodash";

//Result
import { ListTabsResult } from "../Results";

//call Action
import { atcClickResult, actFetchOrderRequest } from "@actions";

//redux
import { useDispatch, useSelector } from "react-redux";

//react-router-dom
import { useParams } from "react-router-dom";

//components PatientSummaryMain
import { PatientSummaryMain } from "../PatientSummary";

//Chat
import { ChatRecordsTab } from "../ChatRecords";

// Check show tabs
function checkIsShow(list, typeToCheck) {
  return list.some((item) => item.Task === typeToCheck);
}

function MedRecordTabContent(props) {
  let { id } = useParams();
  const dispatch = useDispatch();

  //props
  const { isCurrentTask } = props && props;
  const caseData = useSelector((state) => state.cases || []);
  const caseDetails = caseData?.data?.Case;
  const propsVitalSigns = caseDetails?.ClinicalStatus?.VitalSigns;
  const dataClinicalStatus = caseDetails?.ClinicalStatus;
  const measurementsData = dataClinicalStatus?.Measurements;
  const dataInterface = caseDetails?.Interface;
  const IOBalanceData = dataClinicalStatus?.IOBalance;
  const Flow = caseDetails?.Tasks?.Flow;
  const Timeline = caseDetails?.Timeline;
  const TimePointNum = Timeline?.TimePointNum;
  const PriorDocuments = caseDetails?.PriorDocuments;
  const dataVitalSigns = propsVitalSigns && Object.entries(propsVitalSigns);
  const typeMeasurements =
    dataInterface?.Elements && dataInterface?.Elements.Measurements;
  const ShowPatientSummaryPage =
    caseData?.data?.Case?.PatientSummary?.ShowPatientSummaryPage;
  const InteractiveItems = dataInterface?.InteractiveItems;
  const ShowVitals = dataInterface?.ShowVitals;
  const DataLabResults = caseDetails?.ClinicalStatus?.LabResults;
  const studyResultsData = dataClinicalStatus?.StudyResults;
  const hasDataForResult =
    DataLabResults?.results.length > 0 || studyResultsData?.length > 0;

  //state
  const [activeTab, setActiveTab] = useState(isCurrentTask);
  const [arrDotResult, setStatusDotResult] = useState({
    Labs: false,
    Studies: false,
  });
  const [checkDataDiff, setDataDiff] = useState([]);

  //Handle tab
  const toggle = (type) => {
    setActiveTab(type);
    const params = {
      Task: "view_lab",
    };
    //Neu Click Tab Result Thi Mac Dinh Cho Labs Da xem
    type === "Results" && atcClickResult(params, id);
  };

  //Kiem tra xem co luuu o local khong
  useEffect(() => {
    dispatch(actFetchOrderRequest(id));

    //Get local stotage Studies, Labs
    const ClinicalStatusLocalGet = localStorage.getItem("ClinicalStatusLocal");
    const jsonClinicalStatusLocalGet = JSON.parse(ClinicalStatusLocalGet);
    jsonClinicalStatusLocalGet && setDataDiff(jsonClinicalStatusLocalGet);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    //So sanh du lieu cu va du lieu moi dua tren timepoint
    const compareDataTimepoint = (data, type) => {
      // Compare LabResults
      const filterDataBytimePointCurrent = _.filter(data, function (o) {
        return o.TimePointNum === TimePointNum;
      });
      const filterDataBytimePointOld = _.filter(data, function (o) {
        return o.TimePointNum === TimePointNum - 1;
      });
      const objectCurrent =
        filterDataBytimePointCurrent && filterDataBytimePointCurrent[0];
      const objectOld = filterDataBytimePointOld && filterDataBytimePointOld[0];
      const resultsDataCurrent = objectCurrent
        ? objectCurrent[type]?.results || objectCurrent[type]
        : []; // kiem tra neu undefine
      const resultsDataOld = objectOld
        ? objectOld[type]?.results || objectOld[type]
        : []; // kiem tra neu undefine
      const compareResults =
        resultsDataCurrent &&
        resultsDataOld &&
        JSON.stringify(resultsDataCurrent) !== JSON.stringify(resultsDataOld);
      return compareResults;
    };

    //hien thi gia tri khi moi load vao
    const renderDot = (type, value) => {
      if (compareDataTimepoint(checkDataDiff, value) && !arrDotResult[type]) {
        setStatusDotResult((prevState) => ({ ...prevState, [type]: true }));
      }
    };
    renderDot("Labs", "LabResults");
    renderDot("Studies", "StudyResults");
  }, [TimePointNum, arrDotResult, checkDataDiff]);

  //Tabs
  const listNavLink = [
    {
      Title: "Patient Summary",
      Tooltip: "Patient Summary",
      Type: "PatientErm",
      Component: <PatientSummaryMain {...props} />,
      isShow: ShowPatientSummaryPage,
    },
    {
      Title: "Narrative",
      Tooltip: "Narrative",
      Type: "NarrativeHistory",
      Component: <History {...props} />,
      isShow: true,
    },
    {
      Title: "Vital Signs",
      Tooltip: "Vital Signs",
      Type: "VitalSigns",
      Component: (
        <React.Fragment>
          <VitalSignTable data={dataVitalSigns || []} />
          {typeMeasurements?.length > 0 && (
            <Measurements
              {...props}
              type={typeMeasurements}
              data={measurementsData || {}}
            />
          )}
        </React.Fragment>
      ),
      isShow: parseInt(id) !== 754 && ShowVitals,
    },
    {
      Title: "Intake / Output",
      Tooltip: "Intake / Output",
      Type: "IntakeOutput",
      Component: (
        <IOBalance
          active={activeTab}
          data={(IOBalanceData && IOBalanceData) || {}}
        />
      ),
      isShow: Flow?.includes("io"),
    },
    {
      Title: "Orders",
      Tooltip: "Orders",
      Type: "labs",
      Component: <OrderList {...props} active={activeTab} />,
      isShow: checkIsShow(InteractiveItems, "labs"),
    },
    {
      Title: "Results",
      Tooltip: "Results",
      Type: "Results",
      Component: (
        <ListTabsResult
          {...props}
          TimePointNum={TimePointNum}
          arrDotResult={arrDotResult}
        />
      ),
      isShow:
        ![775, 754].includes(Number(id)) &&
        TimePointNum > 1 &&
        hasDataForResult,
    },
    {
      Title: "Docs",
      Tooltip: "Prior Documents & Records",
      Type: "Prior_Documents",
      Component: (
        <PriorDocumentsComponent
          {...props}
          active={activeTab}
          TimePointNum={TimePointNum}
        />
      ),
      isShow: PriorDocuments?.length > 0 || false,
    },
    {
      Title: "Chat Records",
      Tooltip: "Chat Records",
      Type: "Chat_Records",
      Component: <ChatRecordsTab {...props} />,
      isShow: true,
    },
  ];

  //Filter component show
  const listNavShow = _.filter(listNavLink, function (o) {
    return o.isShow;
  });
  const checkActiveTabs = () => {
    let activeTab = null;

    // Ưu tiên tìm theo isCurrentTask trước
    if (isCurrentTask) {
      const currentTaskTab = listNavShow.find(
        (type) => type.Type === isCurrentTask
      );
      if (currentTaskTab) {
        activeTab = currentTaskTab.Type;
      }
    }

    // Nếu không tìm thấy theo isCurrentTask, lấy object đầu tiên
    if (!activeTab && listNavShow.length > 0) {
      activeTab = listNavShow[0].Type;
    }

    return activeTab;
  };

  //Active Tabs - Load lan dau
  useEffect(() => {
    // Nếu không có giá trị isCurrentTask thì xác định tab hoạt động mới
    const newActiveTab = checkActiveTabs();
    if (newActiveTab !== activeTab) {
      setActiveTab(newActiveTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Styled Components
  const TabContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
  `;

  const StyledTabContent = styled(TabContent)`
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
  `;
  return (
    <React.Fragment>
      <TabList
        {...props}
        toggle={(e) => toggle(e)}
        activeTab={activeTab}
        data={listNavShow}
        TimePointNum={TimePointNum}
        arrDotResult={arrDotResult}
      />
      <TabContainer>
        <StyledTabContent activeTab={activeTab}>
          {listNavShow?.map((item, index) => (
            <React.Fragment key={index}>
              {item?.isShow && activeTab === item?.Type && item.Component}
            </React.Fragment>
          ))}
        </StyledTabContent>
      </TabContainer>
    </React.Fragment>
  );
}

export default MedRecordTabContent;
